import type { RoutePermission } from 'features/main/main-router/org-guard/main-container/RouteConfig'

/** The rule the Queues route and menu item share: gap users on the dev or product team. */
export const queuesPermission: RoutePermission = {
   devOrProductTeamOnly: true,
   onlyForOrgs: ['gap'],
}
